module.exports = __webpack_public_path__ + "media/img/illustrations/icons/table-ammended-timesheet-7f6bb3fe1016b815a38a1cf525114f7c.svg";